<script lang="ts">
    import { Col,Progress } from "sveltestrap";
    import { BasicProgressBars, BasicProgressBarsTitle } from "../../../utils/Constant/Constant";
    import Card from "../UiCommenCard.svelte";
</script>
<Card cardHeaderprops="pb-0" headerTitle={BasicProgressBars} headerContent={BasicProgressBarsTitle} CardBodyprops="progress-showcase row">
    <div slot="contentbody">
      <Col>
        <Progress value={0}></Progress>
        <Progress value={25} color="primary"></Progress>
        <Progress value={50} color="secondary"></Progress>
        <Progress value={75} color="success" ></Progress>
        <Progress value={100} color="info"></Progress>
      </Col>
    </div>
</Card>